const e = "shimmer_15-5-1", n = {
  "cdr-skeleton-bone": "cdr-skeleton-bone_15-5-1",
  "cdr-skeleton-bone__shimmer": "cdr-skeleton-bone__shimmer_15-5-1",
  shimmer: e,
  "cdr-skeleton-bone--line": "cdr-skeleton-bone--line_15-5-1",
  "cdr-skeleton-bone--heading": "cdr-skeleton-bone--heading_15-5-1",
  "cdr-skeleton-bone--rectangle": "cdr-skeleton-bone--rectangle_15-5-1",
  "cdr-skeleton-bone--square": "cdr-skeleton-bone--square_15-5-1"
};
export {
  n as default,
  e as shimmer
};
